import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import type KybWorkflow from '@banking/savings-onboarding-app/services/kyb-workflow';
import {
  backButtonClickAction,
  businessManagementScreenUpdateAction,
} from '@banking/ui/workflows/onboarding-kyb/action';
import { action } from '@ember/object';
import { BusinessManagementScreenData } from '@banking/ui/workflows/onboarding-kyb/state';

export default class BusinessManagement extends Controller {
  @service kybWorkflow!: KybWorkflow;

  @action submit(data: BusinessManagementScreenData) {
    this.kybWorkflow.emit(businessManagementScreenUpdateAction(data));
  }

  @action goBack() {
    this.kybWorkflow.emit(backButtonClickAction());
  }
}
